export default __webpack_public_path__ + "static/media/48k.c006df5c.md";